import { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { Page, Skeleton, Stack } from "@/components/ui";

const StudioList = lazy(() =>
  import("../features/studio/StudioList").then((module) => ({ default: module.StudioList })),
);

function Loading() {
  return (
    <Page title="Studio">
      <Stack gap={4}>
        <Skeleton height={32} />
        <Skeleton height={160} />
      </Stack>
    </Page>
  );
}

export const Route = createFileRoute("/console/studio/")({
  component: () => (
    <Suspense fallback={<Loading />}>
      <StudioList />
    </Suspense>
  ),
});
